<template>
  <div id="body" v-title data-title="我的钱包">
    <div class="bg-white">
      <div class="container">
        <div class="my-wallet">
          <div class="my-wallet-t">我的钱包</div>
          <div class="mine-wallet-con">
            <div class="con-list">
              <p>余额</p>
              <p class="wallet-num">{{formset.Balance|number(2)}}</p>
            </div>
            <div class="con-list">
              <p>可提现</p>
              <p class="wallet-num">{{formset.ExtractBalance|number(2)}}</p>
            </div>
          </div>
          <ul class="cash-record">
            <li>
              <a href="javascropt:void(0)" class @click="withdrawalsRecord(3)">提现记录 >></a>
            </li>
            <li>
              <a href="javascropt:void(0)" class @click="withdrawalsRecord(1)">佣金记录 >></a>
            </li>
          </ul>
        </div>
        <br>
        <!-- <p style="padding:5px 10px;color:red">微信支付平台升级中，暂无法提现，给您造成的不便深表歉意！</p> -->
        <a href="javascropt:void(0)" class="btn-tx" @click="immediateWithdrawal()">立即提现</a>
        <!-- <a href="javascropt:void(0)"  style="display: block;
    width: 95%;
    height: 48px;
    background-size: 100% 100%;
    margin: 10px auto;
    text-align: center;
    line-height: 48px;
    color: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    font-size: 18px;
    background: silver;
    border-radius: 50px;" >立即提现</a> -->
        <div class="tx-tips">
          <p>提现规则</p>
          <ul>
            <li>1、用户需是实名制用户</li>
            <li>2、直客订单核销完成之后，订单的佣金方可提现</li>
            <li>3、提现金额需大于10元</li>
            <li>4、每个用户当日只能提现1次，单日单笔限额500元</li>
            <li style="color:red;">5、提现后，中国国旅江苏公司将为您代为申报个税</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";

export default {
  name: "mypurse",
  data: function() {
    return {
      formset: {}
    };
  },
  created: function() {
    this.initMypurse();
  },
  methods: {
    //初始化我的钱包
    initMypurse: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/sysaccount/get", {
          params: {}
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },

    //立即提现
    immediateWithdrawal: function() {
      if (
        this.formset.IdCardIsCheck == 0 ||
        this.formset.Phone == undefined ||
        this.formset.Phone == null ||
        this.formset.Phone.length != 11
      ) {
        Dialog.alert({
          title: "提示信息",
          message: "请先上传身份证信息并绑定手机号"
        }).then(() => {
          this.$router.push("/page/messageset");
          return;
        });
      } else {
        this.$router.push("/page/immediatewithdrawal");
      }
    },
    //提现记录
    withdrawalsRecord: function(RecordType) {
      this.$router.push("/page/withdrawalsrecord?RecordType=" + RecordType);
    }
  }
};
</script>

<style>
.mypurse {
  background-color: rgb(138, 116, 102);
  height: 90px;
  width: 50%;
  float: left;
}
.amount {
  margin-top: 15px;
  text-align: center;
  font-size: 24px;
  color: white;
}
.number {
  text-align: center;
  font-size: 12px;
  color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/mypurse/mypurse.vue